"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 140: Jaleco JF-11 / JF-14
 * ------------------------------------------------------------------ *
 * GxROM (mapper 66) with its register in the work RAM window at
 * $6000-$7FFF -- which leaves no room for SRAM on the board:
 *   bits 4-5: 32 KB PRG bank at $8000-$FFFF
 *   bits 0-3: 8 KB CHR bank at $0000-$1FFF
 * Used by Bio Senshi Dan: Increaser Tono Tatakai.
 * See https://www.nesdev.org/wiki/INES_Mapper_140
 *
 * 141 used to share this file with 140 (both were listed as JF-14
 * boards, and jaleco-jf14.js still implements that register for it).
 * The wiki now identifies 141 as Sachen's 8259, so 140 follows the
 * documented `..PP CCCC` layout here and 141 keeps the old one.
 */

function register(Mappers) {
  Mappers[140] = function (nes) {
    this.nes = nes;
  };

  Mappers[140].prototype = new Mappers[0]();

  Mappers[140].prototype.write = function (address, value) {
    if (address < 0x6000 || address > 0x7fff) {
      // Below the register: RAM, PPU and APU registers as NROM answers them.
      // Above $7FFF there is only PRG ROM, and NROM's write would overwrite
      // the ROM windows in cpu.mem with the value.
      if (address < 0x6000) {
        Mappers[0].prototype.write.apply(this, arguments);
      }
      return;
    }

    // ..PP CCCC -- two bits of 32 KB PRG up top, four of 8 KB CHR below.
    this.load32kRomBank((value >> 4) & 0x03, 0x8000);
    this.load8kVromBank((value & 0x0f) * 2, 0x0000);
  };
}

module.exports = { register: register };
